import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';
import { LottieComponent } from 'ngx-lottie';
@Component({
	selector: 'app-not-found',
	imports: [SharedModule, ButtonComponent, LottieComponent],
	templateUrl: './not-found.component.html',
	styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
	options = {
		path: 'assets/layout/lottie/error404.json',
		loop: true,
		autoplay: true,
	};

	constructor(
		private router: Router,
		private authService: AuthService,
	) {}

	handleGoBack(): void {
		if (this.authService.isAuthenticated()) {
			this.router.navigate(['/dashboard']);
		} else {
			this.router.navigate(['/login']);
		}
	}
}
